import { render, staticRenderFns } from "./VSelectItems.vue?vue&type=template&id=75cdcdcb"
import script from "./VSelectItems.vue?vue&type=script&lang=js"
export * from "./VSelectItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports